const menu = {
  ABOUT: "about",
  PORTFOLIO: "portfolio",
  CONTACT: "contact",
};

export default menu;
    